export default __webpack_public_path__ + "static/media/c4c_1111x600.4c1ad8ce.jpg";